import apiFetch from '@scale/frontend-lib/api-fetch';
import { HydratedWorkerTeam } from '@scale/shared/workerTeams/types';
import { useQuery } from 'react-query';
import { qmQueryClient } from 'react-scale/corp/lib/api/queryClient';
import Promise from 'bluebird';

const MAIN_QUERY_KEY = 'teams';

export function useGetWorkerTeamDataTree({
  teamId,
  cacheTeamsIds,
}: {
  teamId: string;
  cacheTeamsIds: string[];
}) {
  const queryKey = [MAIN_QUERY_KEY, 'worker-teams', teamId];

  const prefetchData: Record<string, HydratedWorkerTeam> | undefined =
    qmQueryClient.getQueryData(queryKey);

  return useQuery<Record<string, HydratedWorkerTeam>>(
    queryKey,
    async () =>
      await apiFetch(null, `corp-api/worker_teams/team_root/${teamId}`, {
        method: 'POST',
        body: { cacheTeamsIds },
      }),
    {
      enabled: !!teamId,
      initialData: prefetchData,
    },
  );
}

export function useGetWorkerTeams({ teamIds }: { teamIds: string[] }) {
  const queryKey = ['useGetWorkerTeams', teamIds];

  return useQuery<HydratedWorkerTeam[]>(
    queryKey,
    async () => {
      return Promise.map(
        teamIds,
        async teamId => {
          return apiFetch<HydratedWorkerTeam>(null, `corp-api/worker_teams/team/${teamId}`, {
            method: 'GET',
          });
        },
        { concurrency: 10 },
      );
    },
    {
      enabled: teamIds.length > 0,
    },
  );
}
